import executeQuery from "#lib/db"
import type { Recipe } from "#types"
import { RecipePreheat } from "#types"

export const getPreheat = async ({ id }: { id: string }): Promise<Recipe> => {
	const list = await executeQuery({
		query: `
			select
				preheat_temp
    		from
	    		recipes
		    where
    			recipeID=${id}`,
	})

	return list.length > 0 ? list[0] : {}
}

export const putPreheat = async (body: RecipePreheat) => {
	const query = `
		update
			recipes
		set
			preheat_temp=${body.preheat_temp}
		where
			recipeID=${body.recipeID}`
	const list = await executeQuery({
		query,
	})

	return list.length > 0 ? list[0] : {}
}
